// Meta Pixel utility — v1.0.1
/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: any;
  }
}

export const META_PIXEL_ID = '1176776697030724';

export function initMetaPixel(pixelId: string): void {
  if (typeof window === 'undefined') return;
  if (window.fbq) return; // já inicializado

  /* Standard Meta Pixel base code */
  (function (f: any, b: Document, e: string, v: string) {
    let n: any;
    let t: HTMLScriptElement;
    let s: HTMLScriptElement | null;
    if (f.fbq) return;
    n = f.fbq = function (...args: any[]) {
      n.callMethod ? n.callMethod(...args) : n.queue.push(args);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e) as HTMLScriptElement;
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0] as HTMLScriptElement | null;
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s);
    } else {
      b.head.appendChild(t);
    }
  })(
    window,
    document,
    'script',
    'https://connect.facebook.net/en_US/fbevents.js'
  );

  window.fbq('init', pixelId);
}

export function trackPixelEvent(event: string, params?: Record<string, any>): void {
  if (typeof window === 'undefined' || !window.fbq) return;
  window.fbq('track', event, params);
}

export function trackPageView(): void {
  trackPixelEvent('PageView');
}

export function trackViewContent(params?: Record<string, any>): void {
  trackPixelEvent('ViewContent', {
    content_name: 'Oferta Instagram Landing Page',
    content_category: 'PNL - Desenvolvimento Pessoal',
    currency: 'BRL',
    value: 97.0,
    ...params,
  });
}

export function trackLead(params?: Record<string, any>): void {
  trackPixelEvent('Lead', {
    content_name: 'CTA Planos Instagram',
    currency: 'BRL',
    value: 97.0,
    ...params,
  });
}

export function trackInitiateCheckout(params?: Record<string, any>): void {
  trackPixelEvent('InitiateCheckout', {
    content_name: 'Plano Completo Bia Holmes',
    currency: 'BRL',
    value: 97.0,
    num_items: 1,
    ...params,
  });
}
